import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function ModalA({ state, children, state2 }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (state) {
      setShow(true);
    }
  }, [state]);

  useEffect(() => {
    if (!state2) {
      handleClose()
    }
  }, [state2])
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button> */}

      <Modal show={show} onHide={handleClose}>
        {children}
      </Modal>
    </>
  );
}

export default ModalA;
